import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';
import { MembersListApiResponse } from './AdminMembersInterface';

const AdminMembersService = {
  // 문의 내역 조회
  getMembersList: async (
    isDeleted: boolean,
    page: number,
    size: number,
    permissionType: string,
    keyword?: string
  ): Promise<MembersListApiResponse> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_admin_member_list(
          isDeleted,
          page,
          size,
          permissionType,
          keyword
        )
      );
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('문의 내역 조회 실패:', error);
      throw error;
    }
  },
};

export default AdminMembersService;
